import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import qs from "qs";
import { useAppDispatch, useAppSelector } from "../../redux/stateHooks";
import {
  clearObject,
  getObjectFields,
  getObjectName,
  getObjectSelectedFields,
  setObjectDetails,
} from "../../redux/reducers/objectSlice";
function SelectFieldsPanel() {
  const [tempSelectedObjectFields, setTempSelectedObjectFields] = useState([
    "Id",
  ]);

  const [searchedFields, setSearchedFields] = useState([]);

  const objectFields = useAppSelector(getObjectFields);
  const preSelectedObjectField = useAppSelector(getObjectSelectedFields);
  const [selectedObjectFields, setSelectedObjectFields] = useState(
    preSelectedObjectField || []
  );
  useEffect(() => {
    setSelectedObjectFields(preSelectedObjectField);
  }, [preSelectedObjectField]);
  const [isObjectAccrodianOpen, setIsObjectAccrodianOpen] = useState(
    preSelectedObjectField?.length > 0
  );
  const objectName = useAppSelector(getObjectName);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  // useEffect(() => {
  //   // console.log("objectName", objectName);
  //   setIsObjectAccrodianOpen(false);
  //   handleReset();
  // }, [objectName]);

  const handleAddToSelectedObject = () => {
    let itemsToAdd = tempSelectedObjectFields,
      selectedObjects = selectedObjectFields;
    // Create a new set to handle the addition of items without duplicates
    const updatedSet = new Set(selectedObjects);

    // Add each item to the set
    itemsToAdd.forEach((item) => {
      // console.log("adding...", item);
      updatedSet.add(item);
    });

    // Convert the set back to an array
    setSelectedObjectFields(Array.from(updatedSet));
    setTempSelectedObjectFields([]);
  };

  const handleRemoveFromSelectedObject = () => {
    let itemsToRemove = tempSelectedObjectFields,
      selectedObjects = selectedObjectFields;
    // Create a new set from the selectedObjects array
    const updatedSet = new Set(selectedObjects);

    // Remove each item from the set
    itemsToRemove.forEach((item) => {
      console.log(item);
      if (item == "Id") return;
      updatedSet.delete(item);
    });

    // Convert the set back to an array
    setSelectedObjectFields(Array.from(updatedSet));
    setTempSelectedObjectFields([]);
  };
  const handleSelectingTempFields = (id) => {
    if (tempSelectedObjectFields.includes(id)) {
      setTempSelectedObjectFields(
        tempSelectedObjectFields.filter((item) => item !== id)
      );
    } else {
      setTempSelectedObjectFields([...tempSelectedObjectFields, id]);
    }
  };

  const handleMoveUp = () => {
    if (tempSelectedObjectFields.length > 1) {
      alert("Select one only to move up/down");
      return;
    }
    let _selectedObjectFields = selectedObjectFields;
    const index = _selectedObjectFields.indexOf(tempSelectedObjectFields[0]);
    // console.log(_selectedObjectFields);
    if (index > 0) {
      // Swap elements
      [_selectedObjectFields[index], _selectedObjectFields[index - 1]] = [
        _selectedObjectFields[index - 1],
        _selectedObjectFields[index],
      ];
    }
    // console.log(_selectedObjectFields);
    setSelectedObjectFields([..._selectedObjectFields]);
  };

  const handleMoveDown = () => {
    if (tempSelectedObjectFields.length > 1) {
      alert("Select one only to move up/down");
      return;
    }
    let _selectedObjectFields = selectedObjectFields;
    const index = _selectedObjectFields.indexOf(tempSelectedObjectFields[0]);
    if (index < _selectedObjectFields.length - 1 && index !== -1) {
      // Swap elements
      [_selectedObjectFields[index], _selectedObjectFields[index + 1]] = [
        _selectedObjectFields[index + 1],
        _selectedObjectFields[index],
      ];
    }
    setSelectedObjectFields([..._selectedObjectFields]);
  };
  const handleSearchFields = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchTerm = e.target.value.toLowerCase();
    const filteredResults = objectFields?.filter((detail) =>
      detail?.name?.toLowerCase()?.includes(searchTerm)
    );
    setSearchedFields([...filteredResults]);
  };
  const handleNext = () => {
    console.log("selectedObjectFields setting", selectedObjectFields);
    if (!selectedObjectFields.includes("Id")) {
      dispatch(
        setObjectDetails({
          selectedObjectFields: ["Id", ...selectedObjectFields],
          runat: Math.random(),
        })
      );
    } else
      dispatch(
        setObjectDetails({ selectedObjectFields, runat: Math.random() })
      );
  };
  const handleReset = async () => {
    setSelectedObjectFields([]);
    dispatch(clearObject());
    setTempSelectedObjectFields([]);
  };
  return (
    <>
      <div className="leftside full-height">
        <fieldset className="full-height">
          <legend>Select Fields</legend>
          <div className="row full-height">
            <div className="col-sm-4 full-height">
              <div className="d-flex available-field">
                <span>Available fields</span>
              </div>
              <div className="availableBox custom-scroll" id="custom-scroll">
                <div className="search-field">
                  <input
                    className="form-control ng-valid ng-dirty ng-touched"
                    placeholder="Search"
                    type="text"
                    onChange={handleSearchFields}
                  />
                  <button className="btn-search" type="button"></button>
                </div>
                <div className="panel-group">
                  <div
                    className={`panel ${
                      isObjectAccrodianOpen ? "panel-open" : ""
                    }`}
                  >
                    <div className={`panel card panel-default`}>
                      {objectName && (
                        <div
                          className="panel-heading card-header"
                          role="tab"
                          onClick={() => {
                            setIsObjectAccrodianOpen(!isObjectAccrodianOpen);
                          }}
                        >
                          <div className="panel-title">
                            <div className="accordion-toggle" role="button">
                              <div accordion-heading="" className="card-header">
                                <h5 className="mb-0 a">
                                  <button className="btn btn-link collapsed">
                                    {/* Account */}
                                    {objectName}
                                  </button>
                                </h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {searchedFields.length > 0 ? (
                        <div
                          className={`panel-collapse ${
                            isObjectAccrodianOpen ? "visible" : "collapse"
                          } in show block h-['auto']`}
                        >
                          <div className="panel-body card-block card-body">
                            <div className="card-body">
                              {searchedFields?.map((x, index) => (
                                <ul
                                  className={`list-unstyled mb-0 cursor-pointer ${
                                    tempSelectedObjectFields.includes(x.id)
                                      ? "selected-color"
                                      : ""
                                  }`}
                                  key={index}
                                  onClick={() => {
                                    handleSelectingTempFields(x.id);
                                  }}
                                >
                                  <li>
                                    <a className="">{x.name}</a>
                                  </li>
                                </ul>
                              ))}
                            </div>
                          </div>
                        </div>
                      ) : (
                        <>
                          {objectFields?.length > 0 && (
                            <div
                              className={`panel-collapse ${
                                isObjectAccrodianOpen ? "visible" : "collapse"
                              } in show block h-['auto']`}
                            >
                              <div className="panel-body card-block card-body">
                                <div className="card-body">
                                  {objectFields?.map((x, index) => (
                                    <ul
                                      className={`list-unstyled mb-0 cursor-pointer ${
                                        tempSelectedObjectFields.includes(x.id)
                                          ? "selected-color"
                                          : ""
                                      }`}
                                      key={index}
                                      onClick={() => {
                                        handleSelectingTempFields(x.id);
                                      }}
                                    >
                                      <li>
                                        <a className="">{x.name}</a>
                                      </li>
                                    </ul>
                                  ))}
                                </div>
                              </div>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-2 pd-lr0">
              <div className="d-flex available-field">
                <span>&nbsp;</span>
              </div>
              <div className="availableBox no-border d-flex align-items-center">
                <div className="full-width btnspace">
                  <button
                    className="btn btn-add btn-block"
                    type="button"
                    onClick={handleAddToSelectedObject}
                  >
                    Add
                  </button>
                  <button
                    className="btn btn-add btn-block"
                    type="button"
                    onClick={handleRemoveFromSelectedObject}
                  >
                    Remove
                  </button>
                </div>
              </div>
            </div>
            <div className="col-sm-4 full-height">
              <div className="d-flex available-field">
                <span>Selected Fields</span>
              </div>
              <div className="availableBox custom-scroll" id="custom-scroll-2">
                <div className="card-body">
                  {selectedObjectFields?.map((id, index) => {
                    let name = objectFields?.find((x) => x.id == id)?.name;
                    if (name) {
                      return (
                        <ul
                          key={index}
                          className={`list-unstyled mb-0 cursor-pointer ${
                            tempSelectedObjectFields.includes(id)
                              ? "selected-color"
                              : ""
                          }`}
                          onClick={() => {
                            handleSelectingTempFields(id);
                          }}
                        >
                          <li>
                            <a>{name}</a>
                          </li>
                        </ul>
                      );
                    }
                  })}
                </div>
              </div>
            </div>
            <div className="col-sm-2 pd-l0">
              <div className="d-flex available-field">
                <span>&nbsp;</span>
              </div>
              <div className="availableBox no-border d-flex align-items-center">
                <div className="full-width btnspace text-center">
                  <button
                    className="btn btn-add btn-icon up"
                    type="button"
                    onClick={handleMoveUp}
                  ></button>
                  <button
                    className="btn btn-add btn-icon down"
                    type="button"
                    onClick={handleMoveDown}
                  ></button>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
      <div className="rightside text-center right-action">
        <button
          className={`btn btn-primary ${
            selectedObjectFields?.length ? "active" : ""
          }`}
          type="button"
          disabled={!selectedObjectFields?.length}
          onClick={() => {
            handleNext();
          }}
        >
          Next
        </button>
        <br />
        <button
          className={`btn btn-primary ${
            selectedObjectFields?.length ? "active" : ""
          }`}
          disabled={!selectedObjectFields?.length}
          type="button"
          onClick={handleReset}
        >
          Reset
        </button>
      </div>
    </>
  );
}

export default SelectFieldsPanel;
